// extracted by mini-css-extract-plugin
module.exports = {"container":"JQ8mjm","icon":"_1pCsxA","shine-lines":"r9RJq_"};